import React from 'react';
import './Stars.scss';

/**
 * Renders stars
 * @param {number} stars
 * @param {string} assetUrl
 * @constructor
 */
const Stars = ({ stars, assetUrl }) => (
  <span
    className="c-stars"
    style={{
      backgroundImage: `url(${assetUrl})`,
      width: `${(Number(stars) / 5) * 5.375}rem`,
    }}
  ></span>
);

export default Stars;
